export const DEFAULT_THEME_COLOR = {
  '--p': '#4a00ff',
  '--s': '#ff00d3'
}
